import { OrderItem } from '@/data/types/Order';

type Attribute = {
	attributeName: string;
	attributeValue: string;
};

export const findExtendedAttributes = (data: OrderItem, keys: Record<string, string>) => {
	const result: Array<{key: string, value: string}> = [];

	const rawAttributes = (data as any)?.orderItemExtendAttribute;
	const attributes: Attribute[] = Array.isArray(rawAttributes) ? rawAttributes : [];

	Object.entries(keys).forEach(([original, alias]) => {
		const attr = attributes.find((a) => a.attributeName === original);
		if (attr) {
			result.push({ key: alias, value: attr.attributeValue });
		}
	});

	return result;
};
